/* eslint-disable react/prop-types */
import React from 'react';
import ParticipationRate from '../ParticipationRate';

const n = (v) => Number(v || 0).toLocaleString();

const ICONS = { up: '▲', down: '▼', flat: '—', new: '★' };
const DELTA_CLASS = { up: 'au-delta--up', down: 'au-delta--down', flat: 'au-delta--flat', new: 'au-delta--flat' };

// Period-over-period delta — icon + text, never colour alone (FR-006/FR-018).
const Delta = ({ delta }) => {
  if (!delta || !delta.direction) return null;
  const { direction, delta_pct: pct } = delta;
  const pill = direction === 'new' ? `${ICONS.new} New`
    : direction === 'flat' ? `${ICONS.flat} 0%`
      : `${ICONS[direction]} ${Math.abs(Number(pct) || 0)}%`;
  const label = direction === 'new' ? 'this period' : 'vs prior period';
  return (
    <span className="ss-delta" aria-label={`${pill} ${label}`}>
      <span className={`au-delta ${DELTA_CLASS[direction]}`}>{pill}</span>
      <span className="ss-delta__lbl">{label}</span>
    </span>
  );
};

const SleepSummarySummaryCards = ({
  totalUsers = 0, totalSessions = 0, totalUserBase = 0, subscribedCount = 0, deltas = {},
}) => (
  <div className="au-cards" data-testid="ss-summary">
    <div className="au-card">
      <span className="au-card__label">Total Users</span>
      <span className="au-card__value tnum">{n(totalUsers)}</span>
      <ParticipationRate className="au-card__sub" count={totalUsers} total={totalUserBase} />
      <span className="au-card__sub" data-testid="ss-subscribed">Subscribed: {n(subscribedCount)}</span>
      <Delta delta={deltas.total_users} />
    </div>
    <div className="au-card">
      <span className="au-card__label">Total Sessions</span>
      <span className="au-card__value tnum">{n(totalSessions)}</span>
      <span className="au-card__def">One distinct sleep session per synced UUID.</span>
      <Delta delta={deltas.total_sessions} />
    </div>
  </div>
);

export default SleepSummarySummaryCards;
